// @ts-check
import React, { useState } from 'react'
import { Button, InputText } from '../../ui'
import { useTranslation } from 'react-i18next'
import { MAX_LENGTH, VALIDATE_EMAIL_REGEXP } from '../../constants/constants'

/**
 * @param {{resendToken: function, isLoadingResend: boolean, className?: string}} props
 */
const ResendEmailFormBase = ({ resendToken, isLoadingResend, className }) => {
  const { t } = useTranslation()
  const [isValidEmail, setIsValidEmail] = useState(false)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} value
   */
  const onChange = ({ currentTarget: { value } }) => {
    const isNewValidEmail = VALIDATE_EMAIL_REGEXP.test(value)
    setEmail(value)
    setIsValidEmail(isNewValidEmail)
    if (isNewValidEmail) {
      setEmailError('')
    }
  }

  const onBlur = () => {
    if (isValidEmail) {
      setEmailError('')
    } else {
      setEmailError('emailField.invalid')
    }
  }

  /**
   * @param {React.FormEvent} e
   */
  const onSubmit = (e) => {
    e.preventDefault()
    if (isValidEmail) {
      resendToken(email)()
    }
  }

  return (
    <form className={className} onSubmit={onSubmit} noValidate id='resendForm'>
      <InputText
        id='resend-email'
        type='email'
        value={email}
        label={t('emailField.email')}
        placeholder={t('emailField.email')}
        error={t(emailError)}
        name='email'
        onChange={onChange}
        onBlur={onBlur}
        maxLength={MAX_LENGTH}
        valid={isValidEmail}
      />
      <Button
        disabled={!isValidEmail || isLoadingResend}
        onClick={resendToken(email)}
        isLoading={isLoadingResend}
      >
        {t('createAccount.resendButton')}
      </Button>
    </form>
  )
}

export { ResendEmailFormBase }
